import React, {useRef} from "react"
import { Link } from "gatsby"
import ComponentWrapper from "../components/wrapper"
import ScrollAnimation from '../helpers/scrollAnimations'
import ToolTip from "./tooltip"

const CopyStacked = ({reverseZindex, bodyCopy, ctaButton, hasTooltip=false, tooltip, storyColor}) => {
    const parentCopyEl = useRef(null);

    return (
        <ComponentWrapper>
            <ScrollAnimation zIndex={reverseZindex}>
                <div className={`copy-stacked`}>
                    <div className="copy-stacked__copy">
                        {bodyCopy && 
                            <div className="wysiwyg" ref={parentCopyEl} dangerouslySetInnerHTML={{__html: bodyCopy}} />
                        }
                    </div>
                    {ctaButton && 
                        <div className="button-container">
                            <Link to={ctaButton.url} className={`button button--${storyColor}`}>{ctaButton.title}</Link>
                        </div>
                    }
                    {hasTooltip &&
                        <ToolTip
                            storyColor={storyColor}
                            tooltip={tooltip}
                            parentCopy={parentCopyEl}
                        />
                    }
                </div>
            </ScrollAnimation>
        </ComponentWrapper>
    )
}

export default CopyStacked